import { HttpClient } from '../../infrastructure/adapter/HttpClient';

export abstract class BaseRepository {
  protected httpClient: HttpClient;
  constructor({ httpClient }: { httpClient: HttpClient }) {
    this.httpClient = httpClient;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/domain/repository/BaseRepository.ts